<button class="scrolldown-btn" (click)="setScrollDown()">
    <fa-icon class="icon" [icon]="faAngleDown"></fa-icon>
</button>